<template>
  <v-container grid-list-lg>
    <v-layout align-center justify-center column fill-height>
      <div class="text-xs-center">
        <img height="35px" src="../../assets/autoRepairLoogo.png" />
      </div>

      <v-card width="500px"  class="mt-5 outlined" >
        <!-- v-if="signUpSuccess" -->

        <v-container grid-list-lg v-if="signUpSuccess">
          <v-layout align-center justify-center row wrap>
            <v-flex xs12>
              <!-- <div class="text-xs-center">
                <v-icon color="green" large>mdi-email</v-icon>
              </div> -->
              <div class="text-xs-center">
                <img height="65px" src="@/assets/icons/email.png" />
              </div>

            </v-flex>
            <v-flex xs12>
              <div class="text-xs-center">
                <h2 class=mb-2>Verify Your Email</h2>
              </div>

            </v-flex>

            <v-flex xs12>
              <div class="text-xs-center">
                <p>Thank you for signing up with Auto Repair Desk! Please check your email to complete your account setup.
                  If you don’t see it in your inbox, be sure to check your spam or junk folder.</p>
              </div>
            </v-flex>

            <v-btn data-cy="signUpResendEmail" large class="white-btn v-btn-with-radius" color="primary"
              @click="resend">Resend
              Email</v-btn>
            <v-btn data-cy="signUpAlreadyVerified" large class="white-btn v-btn-with-radius" to="/login"> Already
              Verified</v-btn>
          </v-layout>
        </v-container>


        <v-card-text v-else>
          <v-layout row fill-height wrap>

            <v-flex xs12>
              <div class="text-xs-center">
                <h1>Create your account</h1>
              </div>
            </v-flex>

            <v-flex xs6>
              <div>First Name</div>
              <v-text-field solo :error-messages="firstNameErrors" :hide-details="firstNameErrors.length === 0"
                data-cy="signUpFirstName" label="Enter your first name" v-model="user.firstName"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <div>Last Name</div>
              <v-text-field solo data-cy="signUpLastName" label="Enter your last name"
                :error-messages="lastNameErrors" :hide-details="lastNameErrors.length === 0"
                v-model="user.lastName"></v-text-field>
            </v-flex>
            <v-flex shrink xs12>
              <div>Email Address</div>
              <v-text-field solo data-cy="signUpEmail" label="Enter your email address" :error-messages="emailErrors"
                :hide-details="emailErrors.length === 0" v-model="user.email"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <div>Passwor</div>
              <v-text-field solo label="Enter password"
                :error-messages="passwordErrors" :hide-details="passwordErrors.length === 0" v-model="user.password"
                type="password"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <div>Confirm Password</div>
              <v-text-field solo :label="$t('labels.confirmPassword')"
                :error-messages="confirmPasswordErrors" :hide-details="confirmPasswordErrors.length === 0"
                v-model="user.confirmPassword" type="password" v-on:keyup.enter="submit"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider class="mt-2"></v-divider>
        <v-card-actions v-if="!signUpSuccess">
          <v-btn flat to="/login">{{ $t('buttons.signIn') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn data-cy="signUpNextBtn" color="primary" dark @click="submit">{{ $t('buttons.next') }}</v-btn>
        </v-card-actions>


      </v-card>

    </v-layout>
  </v-container>
</template>
<script>
import signUpService from './service.js'

const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
  email,
  sameAs,
} = require('vuelidate/lib/validators')

export default {
  name: 'signUp',
  created() {
    if (this.$route.query) {
      this.user.ReferralCode = this.$route.query.referralCode
      this.user.email = this.$route.query.email
      this.user.plan = this.$route.query.plan
      this.user.source = this.$route.query.source
    }
    if (this.$route.params.email) {
      this.user.email = this.$route.params.email
      this.user.firstName = this.$route.params.firstName
      this.user.lastName = this.$route.params.lastName
      this.user.forceVerify = this.$route.params.verified
    }
  },
  data() {
    return {
      user: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        acceptedTerms: false,
        ReferralCode: null,
        confirmPassword: null,
        plan: null,
        forceVerify: false,
      },
      viewTerms: false,
      signUpSuccess: false,
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toasted.error(this.$t('toastMessage.text.invalidFields'), {
          position: 'top-right',
          showHideTransition: 'slide',
          duration: 3500,
        })
      } else {
        signUpService.submit(this.user)
          .then((response) => {
            console.log(response)
            if (this.$route.query.plan || this.user.forceVerify) {
              this.$toasted.success('User created.', {
                position: 'top-right',
                showHideTransition: 'slide',
                duration: 3500,
              })
              this.$router.push({ name: 'newOrganization', params: { plan: this.$route.query.plan } })
            } else {
              this.signUpSuccess = true
            }
          })
          .catch((error) => {
            console.log('test', error)
            this.$toasted.error(error.data.message, {
              position: 'top-right',
              showHideTransition: 'slide',
              duration: 3500,
            })
          })
      }
    },
    resend() {
      console.log(this.email)
      signUpService.resendVerifyEmail({ email: this.user.email })
        .then((response) => {
          console.log(response.data)
          this.$toasted.success(`Resent Email to ${this.user.email}`, {
            position: 'top-right',
            showHideTransition: 'slide',
            icon: 'check',
            duration: 2000,
          })
        })
        .catch((error) => {
          this.$Progress.finish()
          this.isLoading = false
          this.error = true
          this.errorMessage = error.data.message
        })
    },
  },
  computed: {
    firstNameErrors() {
      const errors = []
      if (!this.$v.user.firstName.$dirty) return errors
      if (!this.$v.user.firstName.required) errors.push('First name is required')
      if (!this.$v.user.firstName.minLength) errors.push(this.$t('validations.fieldMustbeatLeast2ChrLong'))
      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.user.lastName.$dirty) return errors
      if (!this.$v.user.lastName.minLength) errors.push(this.$t('validations.fieldMustbeatLeast2ChrLong'))
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.user.email.$dirty) return errors
      if (!this.$v.user.email.required) errors.push('Email address is required')
      if (!this.$v.user.email.email) errors.push('Enter valid email address')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.user.password.$dirty) return errors
      if (!this.$v.user.password.required) errors.push('Password is required')
      if (!this.$v.user.password.minLength) errors.push('Password mast be 4 characters long')
      return errors
    },
    confirmPasswordErrors() {
      const errors = []
      if (!this.$v.user.confirmPassword.$dirty) return errors
      if (!this.$v.user.confirmPassword.sameAsPassword) errors.push('Password des not match!')
      return errors
    },
  },
  mixins: [validationMixin],
  validations: {
    user: {
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        minLength: minLength(2),
      },
      email: {
        email,
        required,
      },
      password: {
        required,
        minLength: minLength(4),
      },
      confirmPassword: {
        sameAsPassword: sameAs('password'),
      },
    },
  },
}
</script>
<style lang="scss" scoped>
h1 {
  font-size: 22px;
  font-weight: 400;
  line-height: 32px;
  margin: 0;
}
</style>
